// Centralised social profile URLs — single source of truth so the footer,
// About page, blog author byline, and JSON-LD `sameAs` all stay in sync.

export const SOCIAL_LINKS = {
  instagram: {
    label: "Instagram",
    url: "https://www.instagram.com/myplainly/",
    handle: "@myplainly",
  },
  linkedin: {
    // Founder's personal LinkedIn — drives author authority (E-E-A-T) on
    // blog posts and the About page.
    label: "LinkedIn",
    url: "https://www.linkedin.com/in/nicholas-steer-409800360/",
    handle: "Nicholas Steer",
  },
};

// All social URLs as a flat array — handy for JSON-LD `sameAs`.
export const SOCIAL_URLS = Object.values(SOCIAL_LINKS).map((s) => s.url);
